export default __webpack_public_path__ + "Papa_Bonus.6dee6161.jpg";